import { render } from "./PopupPreviewEleve.vue?vue&type=template&id=f49aa6a0&scoped=true"
import script from "./PopupPreviewEleve.vue?vue&type=script&lang=js"
export * from "./PopupPreviewEleve.vue?vue&type=script&lang=js"

import "./PopupPreviewEleve.vue?vue&type=style&index=0&id=f49aa6a0&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49aa6a0"]])

export default __exports__